import Ajax from '@utils/ajax';

import {
	AxiosPromise,
} from 'axios';

export function deleteLoan(BhrCldId: number): AxiosPromise {
	return Ajax.delete(`/payroll/deduction_sync/ajax/reset_loan/${ BhrCldId }`);
}
